import { render } from "./FileHandler.vue?vue&type=template&id=da81e53c&scoped=true"
import script from "./FileHandler.vue?vue&type=script&lang=js"
export * from "./FileHandler.vue?vue&type=script&lang=js"

import "./FileHandler.vue?vue&type=style&index=0&id=da81e53c&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da81e53c"]])

export default __exports__